const mapHeroSection = (response: any) => {
  const data: any = {};

  data.badgeTitle = "Recipe";
  data.recipeTitle = response?.title;
  data.subtitle = response?.description;
  data.image = response?.cover_image;
  data.rating = response?.default_rating || "0";
  data.ratingText = "Rating";
  data.aboutRating = response?.liked_by_people_text;
  data.duration = `${response?.cooking_time || 0} Min${
    response?.cooking_time >= 2 ? "s" : ""
  }`;
  data.cookingDuration = response?.cooking_time;
  data.ingredientsCount = `${response?.ingredient_count || 0} Ingredient${
    response?.ingredient_count >= 2 ? "s" : ""
  }`;
  data.ratingCount = response?.rating_count;
  return data;
};

const mapSimilarRecipes = (response: any) => {
  const data: any = {};

  data.similarList = response?.similar_recipes?.data || [];
  data.title = response?.similar_recipes?.title;
  data.ctaTitle = response?.similar_recipes?.cta_button_text;

  return data;
};

const mapModalData = (response: any) => {
  const data: any = {};

  data.closeText = "CLOSE";
  data.image =
    response?.footer_image ||
    "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/app_download_illustration.svg";
  data.title =
    response?.footer_modal_title ||
    "Easy & Tasty Recipes for your Health Goals";
  data.subtitle =
    response?.footer_modal_sub_title || "Healthy Food, Any Day of the Week";
  data.imageOffSetBottom = "-48px";
  data.imageHeight = "200px";
  data.imageWidth = "300px";
  data.rightTitle =
    response?.footer_title ||
    "Find more amazing recipes on the Shyft App. Download Now!";
  data.rightSubtitle =
    response?.footer_sub_title ||
    "Download Shyft Health App and start your wellness journey";

  return data;
};

const mapDownloadBanner = (response: any) => {
  const data: any = {};

  data.appBanner = {
    title:
      response?.footer_title ||
      "Find more amazing recipes on the Shyft App. Download Now!",
    appCard: {
      title:
        response?.footer_title ||
        "Find more amazing recipes on the Shyft App. Download Now!",
      subtitle:
        response?.footer_sub_title ||
        "Download Shyft Health App and start your wellness journey",
      appLinks: [
        {
          link:
            response?.download_app_url?.play_store_link ||
            "https://mindhouse.app.link/bugSoTgftwb",
          icon: "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/website/footer/Google-dark.svg",
          iconDark:
            "https://d1mxd7n691o8sz.cloudfront.net/static/nutrition/nutritiongoal/2023-06/Google_Light-0f53e36e83aa43beaa054bf3c26a69ce.svg",
          text: "play-store",
          external: true,
        },
        {
          link:
            response?.download_app_url?.app_store_link ||
            "https://mindhouse.app.link/bugSoTgftwb",
          icon: "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/website/footer/Apple-dark.svg",
          iconDark:
            "https://d1mxd7n691o8sz.cloudfront.net/static/nutrition/nutritiongoal/2023-06/Apple_Light-6ef14b8a4a4d4f70bfe2ee8b9d016ecd.svg",
          text: "apple-store",
          external: true,
        },
      ],
      image:
        "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/website/footer/footer_illustration.svg",
    },
  };
  data.mobileLink =
    response?.download_app_url?.mobile_link ||
    "https://mindhouse.app.link/bugSoTgftwb";

  return data;
};

const mapAttributes = (response: any) => {
  const data: any = {};

  data.attributes = response?.attributes_l || [];
  data.attributeHeading = "Attributes";

  return data;
};

const mapCollection = (response: any) => {
  const data: any = {};

  data.collections = response?.collections_l || [];
  data.attributeHeading = "Collections";

  return data;
};

const mapIngredientData = (response: any) => {
  const data: any = {};

  data.ingredient = response?.ingredient || [];
  data.ingredientHeading = "Ingredients";

  return data;
};

const mapMethodData = (response: any) => {
  const data: any = {};

  data.methodList = response?.recipe_method || [];

  data.methodListSchema = response?.recipe_method?.map((item: any) => {
    return {
      name: item?.split(" ").slice(0, 5).join(" "),
      item: item,
    };
  });
  data.heading = "Method";

  return data;
};

const mapBreadcrumbData = (response: any) => {
  let data: any = [];

  const { share_url = "", title } = response?.share_details?.[0] || {};

  let [protocol, origin] = share_url.split("//");
  origin = origin?.replace("www.", "");
  origin = origin?.split("recipes")[0];
  const baseUrl = `https://www.${origin}`;

  const { title: attributeTitle, slug } =
    response?.attributes_l?.[0] || response?.collections_l?.[0] || {};
  data = [
    {
      name: "Recipes",
      url: `${baseUrl}recipes`,
    },
    {
      name: attributeTitle,
      url: `${baseUrl}recipes/${
        response?.attributes_l?.length === 0 ? "collection" : "attribute"
      }-${slug}`,
    },
    {
      name: title,
      url: share_url,
    },
  ];
  return data;
};

export const mapRecipeData = (response: any) => {
  const data: any = {};

  data.hero = mapHeroSection(response);
  data.similarRecipes = mapSimilarRecipes(response);
  data.modalData = mapModalData(response);
  data.downloadBanner = mapDownloadBanner(response);
  data.attributeData = mapAttributes(response);
  data.collectionData = mapCollection(response);
  data.ingredientsData = mapIngredientData(response);
  data.methodData = mapMethodData(response);
  data.breadcrumbData = mapBreadcrumbData(response);
  return data;
};
